// extracted by mini-css-extract-plugin
export default {"cls1":"_1LdvPoaAKTv35uNhARvn","cls2":"MJJ6DPLyF1Wn2We9vEEv _1LdvPoaAKTv35uNhARvn"};